import { cloneDeep } from 'lodash';

import AuthNFallbackPolicyApi from 'client/api/v2/AuthNFallbackPolicyApi';
import AuthNFallbackPolicyType, { GlobalAuthPolicyConsts } from 'client/Security/AuthNFallbackPolicyType';
import ConditionalFallbackPolicyModelFactory from 'client/store/modules/models/ConditionalFallbackPolicyModelFactory';

const model = ConditionalFallbackPolicyModelFactory(
  GlobalAuthPolicyConsts.userPortal,
);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    async updateAuthFallbackPolicy({ commit }, objectId) {
      const userPortalFallbackApi = new AuthNFallbackPolicyApi(GlobalAuthPolicyConsts.userPortal);

      const payload = {
        effect: {
          action: 'allow',
          obligations: {
            mfa: { required: false },
            userVerification: { requirement: 'none' },
            externalIdentityProvider: { objectId },
          },
        },
      };

      const result = await userPortalFallbackApi.update(payload);
      const policy = new AuthNFallbackPolicyType(result);

      commit('SET_ITEM_STATE', { create: false, update: true });
      commit('SET_ITEM', cloneDeep({ effect: policy.effect }));
      commit('SET_PREVIOUS_ITEM', cloneDeep({ effect: policy.effect }));
    },
  },

  getters: {
    ...model.getters,
  },

  mutations: {
    ...model.mutations,
  },
};
